<template>
  <d-container fluid class="work-report-view main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Raport</span>
        <h3 class="page-title">Raport pracy</h3>
      </d-col>
    </d-row>

    <validation-observer
      ref="report-filters-form"
      tag="form"
      style="width: 100%;"
      class="page-filters position-relative">

      <div
        v-if="!allFiltersDataLoaded"
        class="pb-3 pt-3 text-center overlay-loading"
        style="z-index: 100;">
        Trwa ładowanie danych&hellip;
      </div>

      <d-row class="ml-0 mb-3 w-100">
        <d-col
          sm="4"
          class="pl-0 pr-1">
          <validation-provider
            rules="required"
            name="report-type"
            v-slot="{ errors }">
            <div :class="{ 'form-control py-0': true, 'is-invalid': errors.length }">
              <v-select
                v-model="filters.reportType"
                :options="allReportTypes"
                :reduce="(reportType) => reportType.id"
                placeholder="Wybierz typ raportu"
                label="value">
                <template slot="no-options">
                  <template>Brak elementów do wyświetlenia</template>
                </template>
              </v-select>
            </div>
          </validation-provider>
        </d-col>

        <d-col
          sm="4"
          class="px-1">
          <validation-provider
            rules=""
            name="report-type-filter"
            v-slot="{ errors }">
            <div :class="{ 'form-control py-0': true, 'is-disabled': !filters.reportType }">
              <v-select
                v-model="filters.filterField"
                :options="filtersForReportType"
                :reduce="(item) => item.id"
                :placeholder="reportTypeFilterPlaceholder"
                :disabled="!filters.reportType"
                label="name">
                <template slot="no-options">
                  <template>Brak elementów do wyświetlenia</template>
                </template>
              </v-select>
            </div>
          </validation-provider>
        </d-col>

        <template v-if="userData.role === 'R_ADMIN' || userData.role === 'R_DEPUTY_DIRECTOR' || userData.role === 'R_RECEPTION'">
          <d-col
            sm="4"
            class="pl-1 pr-0">
            <validation-provider
              rules=""
              name="users"
              v-slot="{ errors }">
              <div :class="{ 'form-control py-0': true, 'is-disabled': !filters.reportType }">
                <v-select
                  v-model="filters.user"
                  :options="allUsers"
                  :reduce="(item) => item.id"
                  :disabled="!filters.reportType"
                  placeholder="Wybierz pracownika"
                  label="name">
                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                      {{ option.name }} {{ option.last_name }}
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      {{ option.name }} {{ option.last_name }}
                    </div>
                  </template>
                  <template slot="no-options">
                    <template>Brak elementów do wyświetlenia</template>
                  </template>
                </v-select>
              </div>
            </validation-provider>
          </d-col>
        </template>
      </d-row>
      <d-row class="ml-0 mb-3 w-100">
        <d-col
          sm="4"
          class="pl-0 pr-1">
          <validation-provider
            rules=""
            name="users"
            v-slot="{ errors }">
            <div :class="{ 'form-control py-0': true, 'is-disabled': !filters.reportType }">
              <v-select
                v-model="filters.institution"
                :options="allInstitutions"
                :reduce="(item) => item.id"
                :disabled="!filters.reportType"
                placeholder="Wybierz placówkę"
                label="name">
                <template slot="no-options">
                  <template>Brak elementów do wyświetlenia</template>
                </template>
              </v-select>
            </div>
          </validation-provider>
        </d-col>

        <d-col
          sm="4"
          class="px-1">
          <validation-provider
            :rules="''"
            name="date_range"
            v-slot="{ errors }">
            <date-picker
              v-model="filters.dateRange"
              validate
              range
              valueType="format"
              style="width: 100%"
              :disabled="!filters.reportType"
              placeholder="Wybierz zakres dat"/>
          </validation-provider>
        </d-col>

        <d-col
          sm="4"
          class="pr-0 pl-1 d-flex">
          <d-button
            theme="primary"
            class="ml-auto mt-auto"
            :disabled="actionInProgress"
            @click.prevent="validateForm">
            Generuj raport
          </d-button>
        </d-col>
      </d-row>
    </validation-observer>

    <d-card style="width: 100%;">
      <table
        v-if="loaded"
        class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0">Lp.</th>
            <th scope="col" class="border-0">{{ currentIdColumnName }}</th>
            <th v-if="isFilesDownloadColumnVisivble" scope="col" class="border-0">Dokumenty</th>
            <th scope="col" class="border-0">Nazwa</th>
            <th scope="col" class="border-0">Data</th>
            <th scope="col" class="border-0">Pacjent</th>
            <th scope="col" class="border-0">Specjalista</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(listItem, index) of reportList"
            :key="'institution-' + index">
            <td class="align-middle">
              {{ index + 1 }}
            </td>
            <td class="align-middle">
              <template v-if="currentReportType === 'VISITS'">
                <router-link
                  :title="'wizyta ' + listItem.id"
                  :to="'/wizyty/edycja/' + listItem.id"
                  target="_blank">
                  {{ listItem.id }}
                </router-link>
              </template>
              <template v-else>
                {{ listItem.id }}
              </template>
            </td>
            <td
              v-if="isFilesDownloadColumnVisivble" class="align-middle">
              <template v-if="currentReportType === 'MEDICAL'">
                <template v-if="listItem.scan_files && listItem.scan_files.length">
                  <a
                    v-for="(file, fileIndex) in listItem.scan_files"
                    :key="'download-file-' + listItem.id + '-' + fileIndex"
                    href="#"
                    theme="info"
                    size="sm"
                    class="mt-1"
                    outline
                    :disabled="downloading"
                    @click.prevent="downloadFile(file.id, file.filename)">
                    <small>{{ file.filename }}</small>
                  </a>
                </template>
                <template v-else>
                  <small>brak</small>
                </template>
              </template>
              <template v-else>
                <a
                  :key="'download-file-' + listItem.id"
                  href="#"
                  theme="info"
                  size="sm"
                  class="mt-1"
                  outline
                  :disabled="downloading"
                  @click.prevent="downloadFile(listItem.id)">
                  <small>{{ currentReportDownlodBtnLabel }}</small>
                </a>
              </template>

            </td>
            <td class="align-middle">
              {{ listItem.name }}
            </td>
            <td class="align-middle">
              {{ listItem.date }}
            </td>
            <td class="align-middle">
              <template v-if="listItem.patient_id">
                <router-link
                  :title="'pacjent ' + listItem.patient_name"
                  :to="'/pacjenci/edycja/' + listItem.patient_id"
                  target="_blank">
                  {{ listItem.patient_name }}
                </router-link>
              </template>
              <template v-else>
                {{ listItem.patient_name || '-' }}
              </template>
              <br>
              <small>nr karty: <strong>{{ listItem.patient_number || 'brak'}}</strong></small>
            </td>
            <td class="align-middle">
              <router-link
                :title="'pracownik ' + listItem.user_name"
                :to="'/uzytkownicy/edycja/' + listItem.user_id"
                target="_blank">
                {{ listItem.user_name }}
              </router-link>
            </td>
          </tr>
          <tr v-if="reportList.length === 0">
            <td
              :colspan="isFilesDownloadColumnVisivble ? 7 : 6"
              class="text-center">
              Brak elementów wyświetlenia&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <d-alert
        v-if="!loaded && !actionInProgress"
        show
        theme="info"
        class="mt-3">
        Aby pobrać listę należy wybrać filtry i kliknąć przycisk "Generuj".
      </d-alert>

      <div v-if="!loaded && actionInProgress" class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>
    </d-card>
  </d-container>
</template>

<script>
import Vue from 'vue';
import FormUtils from '@/utils/FormUtils.js';
import ListUtils from '@/utils/ListUtils.js';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  name: 'work-reports',
  components: { DatePicker },
  computed: {
    allFiltersDataLoaded() {
      return this.allReportTypesLoaded && (this.filters.reportType ? this.filtersForReportTypeLoaded : true) && this.allUsersLoaded && this.allInstitutionsLoaded;
    },
    userData () {
      return this.$store.getters.getAccount
    },
    reportTypeFilterPlaceholder () {
      switch (this.filters.reportType) {
        case 'VISITS':
          return 'Wybierz usługę';
        case 'OPINIONS':
          return 'Wybierz rodzaj opinii';
        case 'DECISIONS':
          return 'Wybierz rodzaj orzeczenia';
        case 'MEDICAL':
          return 'Wybierz rodzaj badania';
        default:
          return 'Filtr dla typu raportu'
      }
    },
    currentIdColumnName () {
      switch (this.currentReportType) {
        case 'VISITS':
          return 'ID wizyty';
        case 'OPINIONS':
          return 'ID opinii';
        case 'DECISIONS':
          return 'ID orzeczenia';
        case 'MEDICAL':
          return 'ID badania';
        default:
          return 'ID'
      }
    },
    isFilesDownloadColumnVisivble () {
      switch (this.currentReportType) {
        case 'OPINIONS':
          return true;
        case 'DECISIONS':
          return true;
        case 'MEDICAL':
          return true;
        default:
          return false
      }
    },
    currentReportDownlodBtnLabel () {
      switch (this.currentReportType) {
        case 'OPINIONS':
          return 'pobierz opinię';
        case 'DECISIONS':
          return 'pobierz orzeczenie';
        case 'MEDICAL':
          return 'pobierz badania';
        default:
          return ''
      }
    },
  },
  watch: {
    'filters.reportType': function (newVal, oldVal) {
      if (newVal && oldVal !== newVal) {
        this.filters.filterField = null;
        this.getFiltersForReportType();
      }
    }
  },
  data() {
    return {
      actionInProgress: false,
      allInstitutions: [],
      allInstitutionsLoaded: false,
      allReportTypes: [],
      allReportTypesLoaded: false,
      allUsers: [],
      allUsersLoaded: false,
      currentReportType: null,
      downloading: false,
      filters: {
        dateRange: null,
        filterField: null,
        institution: null,
        reportType: null,
        user: null
      },
      filtersForReportType: [],
      filtersForReportTypeLoaded: false,
      loaded: false,
      loadError: false,
      reportList: []
    };
  },
  mounted () {
    this.getReportTypes();
    this.loadAdditionalData();
  },
  methods: {
    getReportTypes () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/reports/work-report/get-types',
        method: 'GET',
        outputKey: 'allReportTypes',
        loadedKey: 'allReportTypesLoaded',
        errorKey: 'loadError',
        noPagination: true
      });
    },
    getFiltersForReportType () {
      Vue.set(this, 'filtersForReportTypeLoaded', false);

      FormUtils.loadAdditionalData(this, {
        endpoint: '/reports/work-report/get-filters',
        method: 'POST',
        outputKey: 'filtersForReportType',
        loadedKey: 'filtersForReportTypeLoaded',
        errorKey: 'loadError',
        noPagination: true,
        params: {
          report_type: this.filters.reportType
        },
        successAction: () => {
          if (!this.filtersForReportType.find(item => item.id === 0)) {
            this.filtersForReportType.unshift({ id: 0, name: 'Wszystkie' });
          }
        }
      });
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/users/items',
        method: 'POST',
        outputKey: 'allUsers',
        loadedKey: 'allUsersLoaded',
        errorKey: 'loadError',
        noPagination: false,
        params: {
          pagination: false
        },
        successAction: () => {
          if (!this.allUsers.find(item => item.id === 0)) {
            this.allUsers.unshift({ id: 0, name: 'Wszyscy' });
          }
        }
      });

      FormUtils.loadAdditionalData(this, {
        endpoint: '/institutions/items',
        method: 'POST',
        outputKey: 'allInstitutions',
        loadedKey: 'allInstitutionsLoaded',
        errorKey: 'loadError',
        noPagination: false,
        params: {
          pagination: false
        },
        successAction: () => {
          if (!this.allInstitutions.find(item => item.id === 0)) {
            this.allInstitutions.unshift({ id: 0, name: 'Wszystkie' });
          }
        }
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['report-filters-form'], this.loadFilteredData);
    },
    loadFilteredData () {
      Vue.set(this, 'actionInProgress', true);
      let requestParams = this.prepareFormDataToSend();

      ListUtils.loadItemsData(this, {
        endpoint: '/reports/work-report/get',
        listField: 'reportList',
        pagination: false,
        params: requestParams,
        successAction: () => {
          this.currentReportType = this.filters.reportType;
          Vue.set(this, 'actionInProgress', false);
        },
        failAction: () => {
          this.currentReportType = this.filters.reportType;
          Vue.set(this, 'actionInProgress', false);
        }
      });
    },
    prepareFormDataToSend () {
      let formData = {
        report_type: this.filters.reportType,
        user_id: (this.userData.role === 'R_USER') ? this.userData.id : (this.filters.user || 0),
        institution_id: this.filters.institution || 0,
        filter_field: this.filters.filterField || 0
      }

      if (this.filters.dateRange && this.filters.dateRange[0]) {
        formData.from_date = this.filters.dateRange[0];
      }

      if (this.filters.dateRange && this.filters.dateRange[1]) {
        formData.to_date = this.filters.dateRange[1];
      }
      return formData;
    },
    downloadFile (fileID, filename = '') {
      let endpointUrl = '';
      switch (this.currentReportType) {
        case 'OPINIONS':
          filename = 'Opinia-nr-' + fileID;
          endpointUrl = '/patients/opinions/get-file/' + fileID;
          break;
        case 'DECISIONS':
          filename = 'Orzeczenie-nr-' + fileID;
          endpointUrl = '/pdf-documents/get-file/' + fileID;
          break;
        case 'MEDICAL':
          endpointUrl = 'patients/medical-examinations/scan/get-file/' + fileID;
          return;
        default:
          return;
      }

      Vue.set(this, 'downloading', true);
      this.$http.post(endpointUrl, {}, {
        responseType: 'blob'
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename + '.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        Vue.set(this, 'downloading', false);
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: 'Wystąpił błąd podczas pobierania',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK',
          buttonsStyling: true
        });
        Vue.set(this, 'downloading', false);
      });
    }
  }
};
</script>

<style lang="scss">
.work-report-view .page-filters {
  .form-control {
    padding-bottom: 0;
    padding-left: 0;
    padding-top: 0;

    &.is-disabled {
      background-color: #f8f8f8;

      .v-select .vs__dropdown-toggle {
        background-color: #f8f8f8;
      }
    }

    .v-select .vs__dropdown-toggle {
      border: none!important;
    }
  }

  .mx-input {
    border: 1px solid #e1e5eb;
    box-shadow: none;
    padding-left: 8px;
  }
}
</style>
